export const tsAuctionsFilter = {
  FUEL_TYPE: 'fuelType',
  IS_SELLER: 'isSeller',
  END_DATE_START: 'endDateStart',
  END_DATE_END: 'endDateEnd',
};

export const FORM_ACCOUNT_GOS_AUCTIONS_FILTER =
  'FORM_ACCOUNT_GOS_AUCTIONS_FILTER';
